module.exports = __webpack_public_path__ + "static/img/buxian.3e783e9a.png";